<app-header />
<div class="main-example">
  <app-footer />
</div>
